import { createSelector } from 'reselect'

import { formatOptionsList } from '../../features/formatters'
import { selectedPartnershipSelector } from './partnerships'

// PLOP_APPEND_PATTERN_ANCHOR
export const getCurrentUserIDSelector = createSelector(
  ({ app }) => app.userProfile.data?.id,
  id => id
)

export const getCurrentUserSelector = createSelector(
  ({ app }) => app.userProfile.data,
  data => data
)

export const getCurrentUserIsLoadingSelector = createSelector(
  ({ app }) => app.userProfile.isLoading,
  isLoading => isLoading
)

export const getCurrentUserWasLoadedSelector = createSelector(
  ({ app }) => app.userProfile.wasLoaded,
  wasLoaded => wasLoaded
)

// Submit server logout
export const submitServerLogoutSelector = createSelector(
  ({ app }) => app.submitServerLogout.results,
  results => results
)

export const submitServerLogoutIsLoadingSelector = createSelector(
  ({ app }) => app.submitServerLogout.isLoading,
  isLoading => isLoading
)

export const submitServerLogoutErrorSelector = createSelector(
  ({ app }) => app.submitServerLogout.error,
  error => error
)

export const submitServerLogoutWasLoadedSelector = createSelector(
  ({ app }) => app.submitServerLogout.wasCreated,
  wasCreated => wasCreated
)

export const updateCurrentUserLoadingSelector = createSelector(
  ({ app }) => app.updateUserProfile.isLoading,
  isLoading => isLoading
)

export const updateCurrentUserErrorSelector = createSelector(
  ({ app }) => app.updateUserProfile.error,
  error => error
)

export const updateCurrentUserWasUpdatedSelector = createSelector(
  ({ app }) => app.updateUserProfile.wasUpdated,
  wasUpdated => wasUpdated
)

export const currentUserSelfAccountsListSelector = createSelector(
  ({ app }) => app.userProfile.data,
  data =>
    formatOptionsList({
      list: data && data.accounts,
      valueName: 'id',
      labelName: 'name'
    })
)

export const selectedPlatformSelector = createSelector(
  ({ app }) => app.selectedPlatform,
  selectedPlatform => selectedPlatform
)

export const isAccountSetupModeSelector = createSelector(
  ({ app }) => app.isUserAccountSetupMode,
  isUserAccountSetupMode => isUserAccountSetupMode
)

export const selectedSelfAccountSelector = createSelector(
  ({ app }) => app.selectedSelfAccount,
  selectedSelfAccount => selectedSelfAccount
)

export const selectedPartnershipRightsHolderSelfAccountSelector = createSelector(
  selectedPartnershipSelector,
  currentUserSelfAccountsListSelector,
  (selectedPartnership, selfAccountsList) => {
    const { rights_holder: rightsHolder } = selectedPartnership

    return selfAccountsList.find(selfAccount => selfAccount.id === rightsHolder)
  }
)

export const selectedPartnershipRightsHolderSelfAccountIdSelector = createSelector(
  selectedPartnershipRightsHolderSelfAccountSelector,
  selfAccount => selfAccount?.id
)

export const selectedPartnershipPartnerSelfAccountSelector = createSelector(
  selectedPartnershipSelector,
  currentUserSelfAccountsListSelector,
  (selectedPartnership, selfAccountsList) => {
    const { partner } = selectedPartnership

    return selfAccountsList.find(selfAccount => selfAccount.id === partner)
  }
)

export const userPartnershipAccountSelector = createSelector(
  selectedPartnershipRightsHolderSelfAccountSelector,
  selectedPartnershipPartnerSelfAccountSelector,
  (rightsHolderAccount, partnerAccount) => {
    // user always should be a member of rightsHolderAccount or partnerAccount either both
    // the rightsHolderAccount has a higher priority
    if (!!rightsHolderAccount) {
      return rightsHolderAccount
    } else if (!!partnerAccount) {
      return partnerAccount
    } else {
      return null
    }
  }
)

export const userPartnershipRoleSelector = createSelector(
  userPartnershipAccountSelector,
  selectedPartnershipAccount => {
    if (!!selectedPartnershipAccount) {
      return selectedPartnershipAccount.role
    } else {
      return null
    }
  }
)

export const partnershipAccountTypeSelector = createSelector(
  userPartnershipAccountSelector,
  selectedPartnershipAccount => {
    if (!!selectedPartnershipAccount) {
      return selectedPartnershipAccount.account_type
    } else {
      return null
    }
  }
)

export const searchTermSelector = createSelector(
  ({ app }) => app.searchTerm,
  searchTerm => searchTerm
)

export const bannersSelector = createSelector(
  ({ app }) => app.bannersData.results,
  results => results
)

export const bannersWasLoadedSelector = createSelector(
  ({ app }) => app.bannersData.wasLoaded,
  wasLoaded => wasLoaded
)

export const asyncSessionDataSelector = createSelector(
  ({ app }) => app.asyncSession.data,
  data => data
)

export const themeColorSelector = createSelector(
  ({ app }) => app.themeColor,
  themeColor => themeColor
)

export const themeWasPreselectedSelector = createSelector(
  ({ app }) => app.themeWasPreselected,
  themeWasPreselected => themeWasPreselected
)

export const isNewStylesThemeEnabledSelector = createSelector(
  ({ app }) => app.isNewStylesThemeEnabled,
  isNewStylesThemeEnabled => isNewStylesThemeEnabled
)

export const pdfGenerationSelector = createSelector(
  ({ app }) => app.pdfGeneration,
  pdfGeneration => pdfGeneration
)
